import { render, staticRenderFns } from "./ReplySpellMaker.vue?vue&type=template&id=1163aa0e&"
import script from "./ReplySpellMaker.vue?vue&type=script&lang=js&"
export * from "./ReplySpellMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports